import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from "react";
export var Money = function Money(_ref) {
  var money = _ref.money,
      defaultValue = _ref.defaultValue,
      props = _objectWithoutProperties(_ref, ["money", "defaultValue"]);

  if (!money) {
    return React.createElement("span", props, defaultValue);
  }

  if (money.currency && money.currency !== "") {
    var str = money.amount.toLocaleString("en-US", {
      currency: money.currency,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
      style: "currency"
    });
    return React.createElement("span", props, "".concat(str.slice(0, 1), " ").concat(str.slice(1)));
  }

  return React.createElement("span", props, money.amount.toString());
};
Money.displayName = "Money";
export default Money;